import { activeSessionClaims } from "../http_common.js";

export const CEO_LOGIN_PATH = '/administration/ceo/login';
export const CEO_WORKSPACE_PATH = '/administration/ceo-workspace';

export function getCEOIdentity(queue) {
  return queue?.staffPayload?.staffData || null;
}

export function hasCEORole(queue) {
  const identity = getCEOIdentity(queue);
  const role = identity?.role?.name ?? identity?.role?.code ?? identity?.role;
  return typeof role === 'string' && role.trim().toUpperCase() === 'CEO';
}

const EMPTY_CEO_SESSION = { isAuthenticated: false, queue: {}, dashboard: { nav_trace: '' } };
export function selectCEOSession(state) {
  return state?.universeCEO || EMPTY_CEO_SESSION;
}

export function isCEOAuthenticated(session) {
  const claims = activeSessionClaims(session?.sessionToken, ['STAFF_ACCESS']);
  return session?.isAuthenticated === true && hasCEORole(session.queue) &&
    claims?.role === 'CEO' && claims?.source === 'CEO';
}

export function getCEOName(queue) {
  const personal = getCEOIdentity(queue)?.personalInfo || {};
  return personal.fullName || [personal.firstName, personal.surname || personal.lastName].filter(Boolean).join(' ') || 'Chief Executive Officer';
}
